<template>
	<b-button
		id="ConvoItem"
		variant="outline"
		:disabled="active"
		:class="{ 'd-none': !visible }"
		@click="$emit('groupopen', groupconvo.id, prospect ? prospect.id : null)"
	>
		<div class="d-flex py-2 border-bottom">
			<!-- <div v-if="isOverDue" class="red_duetask_line" style="width: 1em; height:2em" /> -->
			<div class="position-relative" style="width: 3em">
				<!-- <h6>{{convo.Unread > 0}}  {{!convo.Unread}}</h6> -->

				<!-- <h6>{{getUnreadMsgOrMail}} {{getUnreadMsgOrMailClass}}</h6> -->

				<b-button variant="outline" :disabled="groupconvo.Unread > 0" class="dot-btn center p-0 alarm-grey" @click.stop.prevent="markUnread" pill>
					<div :class="{ 'read': !groupconvo.Unread }" class="rounded-circle blue" style="width: 1em; height:1em;" />
				</b-button>

				<!-- <b-button variant="outline" :disabled="getUnreadMsgOrMail" class="dot-btn center p-0 alarm-grey" @click.stop.prevent="markUnread" pill>
					<div :class="{ 'read':getUnreadMsgOrMailClass}" class="rounded-circle blue" style="width: 1em; height:1em;" />
				</b-button> -->
				
				<!-- <b-button v-if="groupconvo.ScheduledCount" variant="outline"  class="alarm-btn">
					<v-icon  class="text-blue start-default" scale="2" name="clock" ></v-icon>
				</b-button> -->

				<!-- <b-button v-if="isOverDue" variant="outline" class="center p-0">
					<div class="red_duetask_line" style="width: 1em; height:1em" />
				</b-button> -->
			</div>
			<div class="flex-fill d-flex flex-column pr-2">
				<div class="d-flex justify-content-between" style="max-width: 300px;margin-left: auto;min-width: 300px;" >
					<div style="max-width: 70%">
						<!-- <h5 v-if="prospect" class="flex-fill before-icon d-flex-wrapper">{{$parseAlias(prospect)}} -->
						<!-- <h5 v-if="prospect" class="flex-fill before-icon d-flex-wrapper">{{groupconvo.FriendlyName}} -->
							
							<!--
							<span  
								v-if="isOverDue.val" 
								
								:class="getClassName"
								:id="prospect.id"
								
							>!</span>
							<b-popover
								:target="prospect.id"
								triggers="hover"
								placement="auto"
								container="my-container"
								ref="popover"
								>
									<b-table-simple v-if="prospect.Tasks" bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
										<b-thead head-variant="light">
											<b-tr class="text-center">
												<b-th>Due Date</b-th>
												<b-th>Task</b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<b-tr
												:key="task.CreatedOn"
												class="text-left position-relative"
												v-for="task of TaskList"
												:class="{'table-danger': task.Status == 'draft' && (task.DueOn <= Date.now())}"
											>
												<b-td>{{$parseDate(task.DueOn)}}</b-td>
												<b-td class="pr-5 position-relative">{{task.Description}}
													<b-button v-if="task.Status != 'compeleted'"
														style="right: 25px"
														variant="outline"
														class="center-vert"
														@click="compeleteTask(task)"
													>
														<v-icon class="text-blue" name="check" />
													</b-button>
													<b-button
														style="right: 0"
														variant="outline"
														class="center-vert"
														@click="removeTask(task)"
													>
														<v-icon class="text-blue" name="times" />
													</b-button>
												</b-td>
											</b-tr>
										</b-tbody>
									</b-table-simple>
							</b-popover>
							-->
							<!-- <div v-if="!prospect.Starred" @click.stop.prevent="startMessage()">
								<v-icon :class="{ 'show_star': !prospect.Starred }" class="text-white start-default" scale="1" name="star" ></v-icon>
							</div>
							<span @click.stop.prevent="unStartMessage()" style="margin-left: 5px;">
								<v-icon v-if="prospect.Starred" class="text-blue start-default" scale="1" name="star" ></v-icon>
							</span> -->
						<!-- </h5> -->
						<!-- <h5 v-else class="flex-fill">{{$parseNumber(groupconvo.UserNumber)}}</h5> -->

						<h5 class="flex-fill before-icon d-flex-wrapper">
							{{showName()}}
						</h5>


						<span id="message" style="color: gray" v-html="getConvertedText"></span>
					</div>
					<div style="text-align: end">
						<!-- <span v-if="isNotToday(convo.DateUpdated)">{{$parsePlainDate(convo.DateUpdated)}}</span><br/>
						<span>{{$parsePlainTime(convo.DateUpdated)}}</span><br/> -->
						<span class="convolistDate">{{$parseDate(groupconvo.DateUpdated)}}</span><br/>
						<!-- <span v-if="prospect" style="color: gray">{{prospect.Status}}</span><br/> -->
						<!-- <span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length && prospect.CciMap.Priority" style="color: gray">Priority: {{prospect.CciMap.Priority}}</span> -->
						<!-- <span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length" style="color: gray">Priority: {{prospect.CciMap.Priority}}</span> -->
					</div>
				</div>
				
			</div>
		</div>
	</b-button>
</template>

<script>
	import { mapState } from 'vuex'
	import { db } from 'src/db'

	export default {
		name: "groupConversationItem",
		props: {
			groupconvo: {
				// ClientNumber: String,
				UserNumber: String,
				LastMessage: String,
				DateUpdated: Number,
				Unread: Number
			},
			active: Boolean,
			filter: Number,
			isPriorityClicked:Boolean
		},
		computed: {
			// getUnreadMsgOrMail() {
			// 	let val = false;
			// 	if (this.groupconvo.Unread > 0 || this.groupconvo.EmailUnread > 0 ) {
			// 		val = true;
			// 	}
			// 	return val
			// },
			// getUnreadMsgOrMailClass() {
			// 	let val = true;
			// 	if (this.groupconvo.Unread || this.groupconvo.EmailUnread) {
			// 		val = false;
			// 	}
			// 	return val
			// },
			formattedMessage() {
				return this.groupconvo.LastMessage.length > 70 ?
						this.groupconvo.LastMessage.substring(0, 70) + "..." :
						this.groupconvo.LastMessage;
			},
			getConvertedText() {
				var urlRegex = /(https?:\/\/[^\s]+)/g;
				return this.formattedMessage.replace(urlRegex, function(url) {
					return '<a href="' + url + '"'+'target="_blank"'+'>' + url + '</a>';
				});
			},
			prospect() {
				for (let prospect of this.prospects) {
					//eslint-disable-next-line
					// console.log('HEY111', this.groupconvo);
					if (prospect.Number == this.groupconvo.UserNumber) {
						return prospect;
					}
				}
				return null;
			},
			// isOverDue() {
			// 	let val = false;
			// 	let taskType = '';
			// 	if(this.prospect && this.prospect.Tasks) {
			// 		for (let task of this.prospect.Tasks) {
			// 			var date_3_day = new Date();
			// 			date_3_day.setDate(date_3_day.getDate() + 3);
			// 			// var date_1_day = new Date();
			// 			// date_1_day.setDate(date_1_day.getDate() + 1);
			// 			var end = new Date();
			// 			end.setHours(23,59,59,999);
			// 			if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
			// 				taskType = 'red'
			// 				val = true;
			// 				break;
			// 			}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
			// 				taskType = 'red'
			// 				val = true;
			// 			}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
			// 				val = true;
			// 				taskType = 'yellow';
			// 			}
			// 			else if (task.DueOn && task.Status == 'draft') {
			// 				val = true;
			// 				taskType = 'gray';
			// 			}
			// 		}
			// 	}
			// 	return {val,taskType}
			// },
			// TaskList() {
			// 	let unCompeletedTaskList = [];
			// 	for (let task of this.prospect.Tasks) {
			// 		var someDate = new Date();
			// 		someDate.setDate(someDate.getDate() + 3);
			// 		// if (task.DueOn && task.Status == 'draft' && ((task.DueOn <= (someDate.getTime()) && task.DueOn >=  Date.now() || task.DueOn <= Date.now()))) {
			// 		// 	unCompeletedTaskList.push(task)
			// 		// }
			// 		// unCompeletedTaskList.push(task)
			// 		if (task.DueOn && task.Status == 'draft') {
			// 			unCompeletedTaskList.push(task)
			// 		}
			// 	}
			// 	return unCompeletedTaskList;
			// },
			
			visible() {

				//eslint-disable-next-line
				// console.log('this.filter>>>>>>', this.filter);

				if (this.filter == -1) {
					return this.prospect && this.prospect.Status == 'Archived';
				}
				
				let numFolders = this.user.Folders ? this.user.Folders.length : 0;
				let iFolder = this.filter - 6;
				let iStage = this.filter - numFolders - 6;

				//eslint-disable-next-line
				//console.log('numFolders:', numFolders);
				//eslint-disable-next-line
				//console.log('iFolder:', iFolder);
				//eslint-disable-next-line
				//console.log('iStage:', iStage);

				//eslint-disable-next-line
				//console.log('this.isPriorityClicked>>>>>>', this.isPriorityClicked);

				if (!this.isPriorityClicked) {
					if (iStage >= 0) {

						//eslint-disable-next-line
						// console.log('iStage>>>>>>', iStage);

						return this.groupconvo;

						// return this.prospect && this.prospect.Status == this.user.Stages[iStage];
					}
					if (iFolder >= 0) {

						//eslint-disable-next-line
						//console.log('iFolder>>>>>>', this.prospect);
							return this.groupconvo;
						// return this.prospect && this.prospect.hasOwnProperty('Tags') && this.prospect.Tags && this.prospect.Tags.includes(this.user.Folders[iFolder]);
					}
				}else {
					// return this.prospect
					return this.groupconvo
				}
				
				
				return !this.prospect || this.prospect.Status != 'Archived';
			},
			// getClassName() {
			// 	let cname = '';
			// 	if (this.isOverDue.taskType == 'yellow') {
			// 		cname = 'yellow'
			// 	}else if(this.isOverDue.taskType == 'gray') {
			// 		cname = 'gray'
			// 	}else if (this.isOverDue.taskType == 'red') {
			// 		cname = 'red'
			// 	}
			// 	return cname;
			// },
			...mapState('firebase', ['user', 'prospects']),
			...mapState('globals', ['unreadCountTotal'])
		},
		created() {
			//eslint-disable-next-line
			// console.log('prospect', this.prospect);
			//eslint-disable-next-line
			// console.log('HEY', this.groupconvo);
			// activegroupProsp
			//eslint-disable-next-line
			// console.log('Hiii', this.groupconvo.id);
		},
		methods: {
			showName() {
				let namee;
				if(this.groupconvo.hasOwnProperty('FriendlyName') && this.groupconvo.FriendlyName != '') {
					namee = this.groupconvo.FriendlyName;
				} else {
					let nameeArray = [];
					this.groupconvo.ProspectNumbers.forEach(gp => {
                        var getData = this.prospects.find(uo => uo.Number == gp);
						if(getData) {
							nameeArray.push(getData.First+' '+getData.Last);
						}
					});
					namee = nameeArray.join(", ");
				}
				return namee;
			},
			isNotToday(milliseconds) {
				let date = new Date(parseInt(milliseconds));
				let now = new Date();
				if (date.getFullYear() === now.getFullYear() &&
					date.getMonth() === now.getMonth() &&
					date.getDate() === now.getDate()) {
					return false;
				}
				return true;
			},
			markUnread() {
				db.doc(`Conversations_v2/${this.groupconvo.id}`).update({Unread: 1});
				this.$store.commit('globals/SET', { var: 'unreadCountTotal', val: this.unreadCountTotal-1 });
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			// compeleteTask(key) {
			// 	if (confirm("Are you sure you want to mark this task as completed?")) {
			// 		// let i=0;
			// 		let taskDesc = '';
			// 		for (let t of this.prospect.Tasks) {
			// 			if (key.CreatedOn == t.CreatedOn) {
			// 				// this.prospect.Tasks.splice(i,1)
			// 				t.Status = 'compeleted';
			// 				t.CompletedOn = Date.now();
			// 				// this.prospect.Tasks.splice(i,1)
			// 				taskDesc = t.Description;
			// 			}
			// 			// i++;
			// 		}
			// 		db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Tasks:this.prospect.Tasks});
			// 		let noteList = this.prospect.Notes;
			// 		let firstNote = {};
			// 		let noteMsg = "Task "+ taskDesc + " was completed";
			// 		if (!noteList) {
			// 			firstNote[Date.now()] = noteMsg;
			// 		} else if (Object.keys(noteList).length > 0) {
			// 			noteList[Date.now()] = noteMsg;
			// 			firstNote = noteList;
			// 		} else {
			// 			firstNote[Date.now()] = noteMsg;
			// 		}
			// 		db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Notes:firstNote});
			// 	}
			// },
			// removeTask(key) {
			// 	if (confirm("Are you sure you want to delete this task?")) {
			// 		let i=0;
			// 		for (let t of this.prospect.Tasks) {
			// 			if (key.CreatedOn == t.CreatedOn) {
			// 				this.prospect.Tasks.splice(i,1)
			// 			}
			// 			i++;
			// 		}
			// 		db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Tasks:this.prospect.Tasks});
			// 	}
			// },
			// startMessage() {
			// 	db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:true});
			// },
			// unStartMessage() {
			// 	// let starred = true;
			// 	// if (this.prospect.hasOwnProperty('Starred') && this.prospect.Starred) {
			// 	// 	starred = false
			// 	// }
			// 	db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:false});
			// }
		}
	}
</script>

<style scoped>
/*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
	#ConvoItem {
		width: 100%;
		padding: 0;
		text-align: left;
		border: 0;
		background-color: white;
	}
	#ConvoItem:disabled {
		background-color: #E0E0E0 !important;
	}
	#ConvoItem:hover {
		background-color: #F8F8F8;
	}
	#message {
		font-size: 12px;
	}
	.read {
		background-color: transparent;
	}
	.read:hover {
		background-color: rgba(4,43,121,.3);
	}
	.show_star {
		background-color:  transparent;
	}
	.show_star:hover {
		background-color: transparent;fill: rgba(4,43,121,.3);
	}
	/* .red_duetask_line {
		border-left-color: red;
		border-left-style: solid;
		border-left-width: thick;
	} */
	.red {
	background-color: transparent;
	}
	.before-icon .red {
	font-size: 18px;margin-right: 5px;
	color: red;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
	}
	.before-icon .yellow {
	font-size: 18px;
	color:#ffc107;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
	}
	.before-icon .gray  {
		font-size: 18px;
		color:gray;
		font-weight: 800;
		object-fit: contain;
		object-position: center;
	}
	h5.flex-fill.before-icon {
	font-size: 14px;
	}
	.d-flex-wrapper{
		display: flex;align-items: baseline;
	}
	.start-default{
		width: 12px !important;height: 12px!important;display: inline-block;
	}
	.alarm-btn{
		padding: 0;
		height: 100%;
		display: flex;
		align-items: flex-end;
		justify-content: center;
		margin: auto;
		padding-bottom: 4px;
	}
	.dot-btn{
		padding-bottom: 15px !important;
	}
	.alarm-grey{
	background-color: transparent !important;
    border: none !important;
	}
	.convolistDate{
		font-size: 14px;
	}
</style>
